import { gql } from '@apollo/client'

import { getMutationService } from '../../../../helpers/GraphqlHelpers'
import { DeclarationFragment } from '../../../fragments/DeclarationFragment'
import { Declaration } from '../../../generated/graphql'
import { UserFragment } from '../../../fragments'

export const saveDeclaration = getMutationService({
  mutation: gql`
    mutation saveDelcaration(
      $function: ID!
      $items: [DeclarationItemInput!]
      $partner: PartnerInput
      $children: [ChildInput!]
    ) {
      saveDeclaration(function: $function, items: $items, partner: $partner, children: $children) {
        ...DeclarationFragment
        user {
          ...UserFragment
        }
      }
    }
    ${DeclarationFragment}
    ${UserFragment}
  `,
  transformer: (response): Declaration => {
    return response.saveDeclaration
  },
})
